import * as React from 'react';
import Alert, { AlertProps } from 'react-bootstrap/Alert';

export interface ErrorAlertProps extends AlertProps {
    message? : string,
    show? : boolean
    // childen : any
}

const ErrorAlert: React.FunctionComponent<ErrorAlertProps> = (props: ErrorAlertProps) => {
    const alertProps = (({ message, show, ...p }) => p)(props);
    return(
        props.show 
        ? 
        <Alert variant="danger" {...alertProps} >
            {props.children}
        </Alert>
        :null
    )
}

ErrorAlert.defaultProps = {
    message : "",
    show : false
}

export default ErrorAlert;